import { Point, utils } from '@gush/candybar';
import Confetti from './Confetti';
import Explosion from './Explosion';
import Demo from './Demo';
import Hand from './Hand';
import { COLORS } from './colors';

const { scaleBetween, lerp } = utils;

const PI = Math.PI;
const BLACK = COLORS.black.DEFAULT;
const WHITE = COLORS.white.DEFAULT;

export default class Cannon {
    constructor() {
        this.mousedown = false;
        this.origin = null;
        this.pointer = null;
        this.radius = 0;
        this.particles = [];
        this.hand = new Hand();
    }

    setup = ({ dpr, bounds }) => {
        ['mousedown', 'touchstart'].forEach((event, touch) => {
            window.addEventListener(event, this.pointerDown(touch, dpr), false);
        });
        ['mouseup', 'touchend', 'touchendoutside'].forEach((event, touch) => {
            window.addEventListener(event, this.pointerUp(touch, dpr), false);
        });

        // this.demo = new Demo({
        //     pointerDown: this.pointerDown(false, 1),
        //     pointerUp: this.pointerUp(false, 1),
        // });

        // this.demo.setup({ bounds });
        this.hand.setup({ bounds, dpr });
    };

    pointerDown = (touch, dpr) => (e) => {
        console.log(e);
        this.mousedown = true;
        const x = touch ? e.touches[0].clientX * dpr : e.clientX * dpr;
        const y = touch ? e.touches[0].clientY * dpr : e.clientY * dpr;
        this.origin = new Point(x, y);
        this.hand.setHandDown({ x, y });
    };

    pointerUp = (touch, dpr) => (e) => {
        console.log(e);
        const x = touch ? e.changedTouches[0].clientX * dpr : e.clientX * dpr;
        const y = touch ? e.changedTouches[0].clientY * dpr : e.clientY * dpr;
        this.endPosition = new Point(x, y);
        this.mousedown = false;
        this.fireCannon = true;
        this.hand.setHandUp();
    };

    addConfetti = ({ bounds, addEntity, dpr }) => {
        let amount = Math.floor(this.radius / dpr) * 5;

        const distance = this.endPosition.distance(this.origin);

        if (distance < 2) return;

        const power = scaleBetween(distance, 0, 1, 0, bounds.w);
        const angle = this.endPosition.angleRadians(this.origin);

        while (amount) {
            addEntity(
                new Confetti({
                    x: this.origin.x,
                    y: this.origin.y,
                    power,
                    angle,
                })
            );
            --amount;
        }

        const multiplier = distance / 10;

        addEntity(
            new Explosion({
                multiplier,
                x: this.origin.x,
                y: this.origin.y,
                velocity: new Point(0, 0).moveAtAngle(angle, multiplier),
            })
        );

        this.fireCannon = false;
    };

    drawCannon({ ctx, dpr, pointer }) {
        const p1 = this.origin;
        const p2 = pointer.position;

        const dist = Math.floor(p1.distance(p2) / 2);
        const [dx, dy] = p1.delta(p2);

        let i = dist;
        let color = BLACK;
        let alternate = 15 * dpr;

        while (i >= 0) {
            if ((dist - i) % alternate === 0) {
                color = color === BLACK ? WHITE : BLACK;
            }
            const n = i / dist;
            const x = lerp(p1.x, p2.x, n);
            const y = lerp(p1.y, p2.y, n);
            const r = lerp(this.radius, 0, n);
            ctx.fillStyle = color;
            ctx.beginPath();
            ctx.arc(x, y, r, 0, PI, true);
            ctx.closePath();
            ctx.fill();
            ctx.fillStyle = color == BLACK ? WHITE : BLACK;
            ctx.beginPath();
            ctx.arc(x, y, r, 0, PI, false);
            ctx.closePath();
            ctx.fill();
            i -= dpr;
        }

        let j = this.radius;
        while (j >= 0) {
            color = color === WHITE ? BLACK : WHITE;
            const x = p1.x;
            const y = p1.y;
            const r = j;
            ctx.fillStyle = color;
            ctx.beginPath();
            ctx.arc(x, y, r, 0, PI * 2, true);
            ctx.closePath();
            ctx.fill();
            j -= 5 * dpr;
        }
    }

    draw = (context) => {
        // TODO switch from demo to pointer
        // const pointer = this.demo;
        const pointer = context.pointer;

        if (this.mousedown) {
            this.radius = this.origin.distance(pointer.position) / 5;
            this.drawCannon({
                ctx: context.ctx,
                dpr: context.dpr,
                pointer,
            });
        }

        this.hand.draw({
            pointer,
            ctx: context.ctx,
            dpr: context.dpr,
            bounds: context.bounds,
        });
    };

    update = (context) => {
        if (this.fireCannon) {
            this.addConfetti(context);
        }
        // this.demo.update(context);
    };
}
